export default __webpack_public_path__ + "static/media/Yakkertech.efae94cf.png";